import lookema from '../../assets/img/Lookema.jpg'
import babysitter from '../../assets/img/Babysitter.png';
import golden from '../../assets/img/Golden.png';

export const DataProjects = [
  {
    'id': 1,
    'name': 'Pokedex',
    'technologies': ['React', 'React Router', 'Sass', 'Context'],
    'src': lookema,
    'url': 'https://github.com/alberthfabian/pokedex'
  },
  {
    'id': 2,
    'name': 'Babysisster',
    'technologies': ['React', 'React Router', 'Sass', 'Context', 'Xd'],
    'src': babysitter,
    'url': 'https://github.com/alberthfabian/babysitter'
  },
  {
    'id': 3,
    'name': 'Papelería Golden',
    'technologies': ['WordPress', 'Plugins', 'IP Acquisition', 'Hosting Acquisition'],
    'src': golden
  }
];